import { HTTP_AP_CreateCompany_Request } from '@api-new/companyservice';
import { CreateCompanyFormValues } from '@platform/company/pages/company-create/forms/create-company.form';

export const createCompanyFormToHttpRequestAdapter = (
  data: CreateCompanyFormValues,
  logoUploadUrl: string,
): HTTP_AP_CreateCompany_Request => {
  const { newLogo: _, ...company } = data;
  return {
    ...company,
    logoUploadUrl,
    fcaNumber: company.fcaNumber.toString(),
  };
};
